<template>
    <NuxtIcon
        :class="definedColor(color) ? null : color"
        :size="definedSize(size) ? null : size"
        :customize="$attrs.customize || customize"
        :style="iconStyles"
        :name="iconName" />
</template>

<script setup lang="ts">
const {
    name,
    iconType,
    module,
    size,
    color,
    colorValue,
    iconStrokeWidth,
    iconStroke,
    iconFill,
    iconOpacity
} = defineProps<{
    name?: string,
    module?: string,
    size?: string | number,
    color?: string,
    colorValue?: string,
    iconType?: string,
    iconStrokeWidth?: string,
    iconStroke?: string,
    iconFill?: string,
    iconOpacity?: string,
}>()

const iconName = computed(() => {
    if (name) return name
    if (module) return $getModuleIcon(module || null)
    if (iconType) return $getIcon(iconType || null)
    return 'none'
})

const attrs = useAttrs()
const {build, definedColor, definedSize} = useStyles()

const iconStyles = computed(() => build().textColor(color, colorValue || '500').sizing(size).watchFor(attrs.class).get())

const customize = (content: string) => {
    let newContent = content

    if (iconStrokeWidth || iconStrokeWidth === 0)
        newContent = newContent.replace(/stroke-width="[^"]*"/g, `stroke-width="${iconStrokeWidth}"`)
    if (iconStroke)
        newContent = newContent.replace(/stroke="[^"]*"/g, `stroke="${iconStroke}"`)
    if (iconFill)
        newContent = newContent.replace(/fill="[^"]*"/g, `fill="${iconFill}"`)
    if (iconOpacity || iconOpacity === 0)
        newContent = newContent.replace(/opacity="[^"]*"/g, `opacity="${iconOpacity}"`)
    return newContent
}
</script>